import { UncontrolledTooltip } from "reactstrap";
import { useUserPermissions } from "../../utils/hooks/useUserPermissions";

const DeleteButton = ({
  onClick,
  color = "red",
  fontSize = 17,
  cursor = "pointer",
  style = {},
  tooltip = null,
  id = null,
  ...props
}) => {
  const { canDelete } = useUserPermissions();
  if (!canDelete()) return;
  return (
    <>
      {canDelete() && (
        <>
          <i
            className="mdi mdi-trash-can"
            title="Excluir"
            style={{
              color,
              fontSize,
              cursor,
              ...style,
            }}
            onClick={onClick}
            {...props}
            id={id}
          />
          {tooltip && id && (
            <UncontrolledTooltip
              style={{ backgroundColor: "#6f42c1" }}
              placement="bottom"
              target={id}
            >
              {tooltip}
            </UncontrolledTooltip>
          )}
        </>
      )}
    </>
  );
};

export default DeleteButton;
